<script setup lang="tsx">
import { ref, watch, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const el = ref();
const width = ref(0);
const height = ref(0);
watch(el, () => {
  if (!el.value) {
    return;
  }
  const rect = el.value.getBoundingClientRect();
  width.value = rect.width;
  height.value = rect.height;
});

const mappedState = mapState(["color.foregroundBorderReverse"]);

const color = ref();

watchEffect(() => {
  color.value =
    props.color || mappedState["color.foregroundBorderReverse"].value;
});
</script>

<template>
  <div
    ref="el"
    :style="{
      display: 'block',
      width: '100%',
      height: '100%'
    }"
  >
    <!-- 不设置 width height , 自适应父元素 -->
    <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
    <svg
      :viewBox="`0 0 ${width} ${height}`"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="none"
      fill="none"
      :style="{
        display: 'block',
        transformOrigin: 'center'
      }"
    >
      <ellipse
        :cx="width * 0.5"
        :cy="height * 0.5"
        :rx="width * 0.5"
        :ry="height * 0.5"
        :fill="color"
      />
    </svg>
  </div>
</template>
